import React from 'react';

const DottedLoader = ({ text = "Loading...", showText = true, size = "default" }) => {
  const dotSizes = {
    small: "w-2 h-2",
    default: "w-3 h-3",
    large: "w-4 h-4"
  };

  const containerSizes = {
    small: "gap-1",
    default: "gap-2",
    large: "gap-3"
  };

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div className={`flex items-center ${containerSizes[size]}`}>
        <div className={`${dotSizes[size]} bg-orange-500 rounded-full animate-bounce`} style={{ animationDelay: '0ms' }}></div>
        <div className={`${dotSizes[size]} bg-orange-500 rounded-full animate-bounce`} style={{ animationDelay: '150ms' }}></div>
        <div className={`${dotSizes[size]} bg-orange-500 rounded-full animate-bounce`} style={{ animationDelay: '300ms' }}></div>
      </div>
      {showText && (
        <p className="text-gray-600 dark:text-gray-400 font-medium mt-4">{text}</p>
      )}
    </div>
  );
};

export default DottedLoader; 